/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useContext, useEffect, useState } from 'react';
import { Loader, TableBillingYearly } from '../../../../components';
import { Admin } from '../../../../utils/api';
import { ARMcontext } from '../../../../utils/context/context';
import { HistorySection, HistoryTable } from './styles';

const defaultHistory = [];

export default () => {
  const { HandleToastMessage } = useContext(ARMcontext);
  const [history, useHistory] = useState<object | any>(defaultHistory);
  const [loading, useloading] = useState(true);
  const ADMIN = new Admin();

  useEffect(() => {
    GetHistoryInfo();
  }, []);

  async function GetHistoryInfo() {
    const data = await ADMIN.GetBillingHistory();
    if (data.status) {
      useHistory(data.data);
    } else {
      HandleToastMessage(data?.data?.message || 'Error fetching the data', true, 2000, 'error');
    }
    useloading(false);
  }

  return (
    <HistorySection data-cy="billing-history">
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '751px', height: '350px' }}>
          <Loader height="90px" />
        </div>
      ) : (
        <HistoryTable>
          <TableBillingYearly dataTableContent={history.yearlyPrepaid} />
        </HistoryTable>
      )}
    </HistorySection>
  );
};
